export enum ModalButtonOptions {
	YES_NO,
	OKAY,
	ADD_CANCEL,
	SAVE_CANCEL,
	DELETE_CANCEL,
}
